<template>
	<div class="row">
		<div class="col-md-12">
			<h1>Calendar</h1>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['user', 'isAuth', 'item'],
		components: {
		},
		data () {
			return {
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
			},
			reload() {
				this.$emit('reload')
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Calendar.vue